module.exports = __webpack_public_path__ + "./docs/img/big-icon-howto.af3427f0e5cab4f6c7f29f92cb9c248a.svg";